import { render } from "./App.vue?vue&type=template&id=2329bd3d"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2329bd3d&lang=css"
script.render = render

export default script